import { render, staticRenderFns } from "./ColumnistAddUpdate.vue?vue&type=template&id=e04f8790&"
import script from "./ColumnistAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ColumnistAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ColumnistAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports